var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"stitch-icon"},[_c(_vm.icon,{ref:"icon",tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }